
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, Save, X } from 'lucide-react';

interface CustomerFormActionsProps {
  onBack: () => void;
  saving: boolean;
}

const CustomerFormActions = ({ onBack, saving }: CustomerFormActionsProps) => {
  return (
    <div className="flex justify-between">
      <Button 
        type="button" 
        variant="outline" 
        onClick={onBack}
        disabled={saving}
      >
        <X className="mr-2 h-4 w-4" />
        Annuler
      </Button>
      <Button 
        type="submit"
        disabled={saving}
        className="bg-indigo-500 hover:bg-indigo-600 text-white px-5 py-2 rounded-md"
      >
        {saving ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Enregistrement...
          </>
        ) : (
          <>
            <Save className="mr-2 h-4 w-4" />
            Enregistrer
          </>
        )}
      </Button>
    </div>
  );
};

export default CustomerFormActions;
